/** True when running inside an iframe / embed frame */
export function isInIframe(): boolean {
  try {
    return typeof window !== 'undefined' && window.self !== window.top
  } catch {
    // cross-origin iframe access throws
    return true
  }
}
